import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../components/Icon';
import { api } from '../lib/api';
import { money } from '../lib/format';
import { useSession } from '../lib/session';

interface Doc {
  id: string;
  number: string;
  title: string | null;
  counterpartyName: string | null;
  status: string;
  totalMinor: number;
  currency: string;
  data?: Record<string, unknown>;
}

export function Recurring() {
  const { company, caps } = useSession();
  const nav = useNavigate();
  const [contracts, setContracts] = useState<Doc[] | null>(null);

  const available = caps?.activeIds.includes('invoice.recurring');

  useEffect(() => {
    if (!company || !available) return;
    setContracts(null);
    // Base de la recurrencia: contratos firmados que dan pie a facturación periódica.
    api.get<Doc[]>('/documents?types=contract&status=signed').then(setContracts).catch(() => setContracts([]));
  }, [company, available]);

  return (
    <main className="main">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">Ventas</span>
          <h1 className="h1">Recurring Invoicing</h1>
          <p className="page-head__sub">Turns a signed contract into a series of recurring invoices. Here you will see the contracts that can generate recurrence and the active series.</p>
        </div>
      </div>

      {!available ? (
        <div className="card">
          <div className="card__body" style={{ padding: 40, textAlign: 'center' }}>
            <div style={{ width: 52, height: 52, margin: '0 auto 16px', borderRadius: 14, display: 'grid', placeItems: 'center', background: 'var(--card-sunken)', color: 'var(--accent)' }}>
              <Icon name="clock" size={24} />
            </div>
            <h2 className="h2" style={{ marginBottom: 8 }}>Disponible en planes superiores</h2>
            <p className="muted" style={{ maxWidth: '44ch', margin: '0 auto 20px' }}>Recurring invoicing is part of a higher plan. You can enable it from the subscription.</p>
            <button className="btn btn--accent" onClick={() => nav('/administracion/suscripcion')}>Ver planes<Icon name="arrow-right" size={16} /></button>
          </div>
        </div>
      ) : (
        <div className="card">
          <div className="card__head"><span className="card__title">Contratos que pueden generar recurrencia</span></div>
          <div className="card__body card__body--flush">
            {!contracts && <div className="empty">Loading…</div>}
            {contracts && contracts.length === 0 && (
              <div className="empty">No signed contracts yet. Sign a contract to generate recurring invoices from it.</div>
            )}
            {contracts && contracts.map((c) => (
              <button key={c.id} className="todo-item" onClick={() => nav(`/documentos/${c.id}`)}>
                <Icon name="clock" size={17} className="todo-item__ico" />
                <span className="todo-item__body">
                  <span className="todo-item__title">{c.number}{c.counterpartyName ? ` · ${c.counterpartyName}` : ''}</span>
                  <span className="todo-item__meta">{c.title ?? 'Contrato firmado'}</span>
                </span>
                <span className="todo-item__amt">{money(c.totalMinor, c.currency)}</span>
              </button>
            ))}
          </div>
        </div>
      )}
    </main>
  );
}
